import { PosSelect } from 'src/core/POS/PosSelect';

import {
  PurchaseVendorSelectorProps,
  usePurchaseVendorSelector,
} from './usePurchaseVendorSelector';

export function PurchaseVendorSelector({
  disabled,
  additionalOptions,
  additionalOptionsPosition,
  placeholderText,
  ...props
}: PurchaseVendorSelectorProps) {
  const { posSelectProps } = usePurchaseVendorSelector({
    additionalOptions,
    additionalOptionsPosition,
    placeholderText,
  });

  return <PosSelect {...props} disabled={disabled} {...posSelectProps} />;
}
